import type { BaseIconProps } from "@/assets/icons/geist/utils";
import type { FC } from "react";

export const IconRightPanel: FC<BaseIconProps> = ({ size, className, ...props }) => {
    switch (size) {
        case "sm":
            return (
                <svg
                    className={className}
                    {...props}
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M12.0833 2.75H3.91667C3.27233 2.75 2.75 3.27233 2.75 3.91667V12.0833C2.75 12.7277 3.27233 13.25 3.91667 13.25H12.0833C12.7277 13.25 13.25 12.7277 13.25 12.0833V3.91667C13.25 3.27233 12.7277 2.75 12.0833 2.75Z"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path d="M6.25 2.75V13.25" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
                    <path
                        d="M9.16666 6.25L10.9167 8L9.16666 9.75"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            );
        case "base":
            return (
                <svg
                    className={className}
                    {...props}
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M14.6667 4H5.33333C4.59695 4 4 4.59695 4 5.33333V14.6667C4 15.403 4.59695 16 5.33333 16H14.6667C15.403 16 16 15.403 16 14.6667V5.33333C16 4.59695 15.403 4 14.6667 4Z"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path d="M8 4V16" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
                    <path
                        d="M11.3333 8L13.3333 10L11.3333 12"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            );
        case "lg":
            return (
                <svg
                    className={className}
                    {...props}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M17.25 5.25H6.75C5.92157 5.25 5.25 5.92157 5.25 6.75V17.25C5.25 18.0784 5.92157 18.75 6.75 18.75H17.25C18.0784 18.75 18.75 18.0784 18.75 17.25V6.75C18.75 5.92157 18.0784 5.25 17.25 5.25Z"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path d="M9.75 5.25V18.75" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
                    <path
                        d="M13.5 9.75L15.75 12L13.5 14.25"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            );
    }
};
